import { IsNotEmpty, IsBoolean } from "class-validator";

export class EnvLanguageStatusDto {
  @IsNotEmpty()
  @IsBoolean()
  enabled: boolean;
}
